import Raven from 'raven-js';
if (PUBLIC_DSN) {
  Raven.config(PUBLIC_DSN, {
    release: GIT_RELEASE,
  }).install();
}

Raven.context(() => {
  require('./index');
});
